import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-decline-data-error',
    templateUrl: './decline-data-error.component.html',
    styleUrls: ['./decline-data-error.component.css']
})
export class DeclineDataErrorComponent implements OnInit {

    constructor(private router: Router) {
        void (0);
    }

    ngOnInit(): void {
        void (0);
    }

    onBackClick() {
        this.router.navigateByUrl('/');
    }
}